import { useAuth } from '@clerk/clerk-react';
import { useEffect, useRef } from 'react';
import { ethereumService } from '../utils/ethereum';
import { useProject } from '../projects/ProjectContext';

export function useWireEthereumAuth() {
  const { getToken } = useAuth();
  const getTokenRef = useRef(getToken);
  useEffect(() => {
    getTokenRef.current = getToken;
  }, [getToken]);
  const { currentProjectId } = useProject();

  useEffect(() => {
    ethereumService.setAuthTokenGetter(() => getTokenRef.current());
  }, []);

  useEffect(() => {
    ethereumService.setProjectIdGetter(() => Promise.resolve(currentProjectId));
    // Important: master wallet is project-scoped. Re-initialize on project change
    // so `ethereumService.masterWallet` matches the selected project.
    if (currentProjectId) {
      ethereumService.reloadConfig().catch(() => {});
    }
  }, [currentProjectId]);
}

